const footerLinks = [
  { label: '作品浏览', href: '#browse' },
  { label: '排行榜', href: '#ranking' },
  { label: '更新时间表', href: '#schedule' },
  { label: '观看指南', href: '#guide' },
  { label: '常见问题', href: '#faq' },
];

const topicLinks = [
  { label: '在线观看', href: '#browse' },
  { label: '高清播放', href: '#guide' },
  { label: '免费浏览', href: '#guide' },
  { label: '全集收录', href: '#schedule' },
  { label: '无广告说明', href: '#guide' },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flower-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">
                樱花动漫在线
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200 max-w-md">
              一个围绕动漫作品整理内容的信息页面，聚焦在线观看、播放、高清与免费等需求，同时补充全集收录与无广告说明，帮助你在开始观看前先判断值不值得花时间。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="px-3 py-1 rounded-full text-xs bg-secondary-800 text-secondary-100">高清画质</span>
              <span className="px-3 py-1 rounded-full text-xs bg-secondary-800 text-secondary-100">无广告</span>
              <span className="px-3 py-1 rounded-full text-xs bg-secondary-800 text-secondary-100">全集收录</span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">站内导航</h3>
            <ul className="space-y-2.5 text-sm">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-secondary-200 transition-colors hover:text-primary-300">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">浏览主题</h3>
            <ul className="space-y-2.5 text-sm">
              {topicLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-secondary-200 transition-colors hover:text-primary-300">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-secondary-300">
            © 2026 樱花动漫在线 · 本页为作品信息整理页面
          </p>
          <p className="text-xs text-secondary-300">
            页面内容仅供参考，作品信息以实际更新为准
          </p>
        </div>
      </div>
    </footer>
  );
}